module.exports = __webpack_public_path__ + "media/images/basic-logos/cancel-645bfb316d48143a7df07161cf9b3597.svg";